import { withInstall } from '@hd-front-end/utils'
import ColorPicker from './src/color-picker.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElColorPicker: SFCWithInstall<typeof ColorPicker> =
  withInstall(ColorPicker)
export default ElColorPicker

export * from './src/color-picker'
